import wx from 'weixin-js-sdk'
import https from './https'
const  wxShare=function(info){
    //微信分享
    // var that=this;
    var url=new Object();
    url.url=window.location.href.split('#')[0];
    https.fetchPost("Wechat/wxShare",url)
    .then(res=>{
        var data=res.data.data;
        wx.config({
            debug: false,
            appId: data.appid,
            timestamp: data.timestamp,
            nonceStr: data.noncestr,
            signature: data.signature,
            jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage'
            ]
        });
        wx.ready( function() {
            var title=!info ? "关爱保险商城" : info.title ;
            var link=!info ? window.location.href.split('#')[0] : info.link;
            var imgUrl=!info ? "../assets/imgs/logo.png" : info.imgUrl; 
            var desc=!info ? "关爱您的健康" : info.desc;     //描述信息
            wx.onMenuShareTimeline({//朋友圈
                title: title, // 分享标题
                link: link, // 分享链接
                imgUrl:imgUrl, // 分享图标
                success: function () {
                },
                cancel: function () {
                }
            });
            wx.onMenuShareAppMessage({//好友
                title: title, // 分享标题
                desc:desc, //描述
                link: link, // 分享链接
                imgUrl: imgUrl, // 分享图标
                type: '', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function () {},
                cancel: function () {
                }
            });
        })
    });  
};


export{
    wxShare,
}



// WEBPACK FOOTER //
// ./src/utils/share.js